import { GrievanceNotification } from "@/@types/sintegrada/GrievanceNotification";
import { getSintegradaServerApi } from "@/services/api";

type GrievanceNotificationParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

export async function getGrievanceNotifications(params: GrievanceNotificationParams) {
	const response = await getSintegradaServerApi().get<GrievanceNotification[]>(
		`/grievance-notifications`,
		params
	);
	return response.data || [];
}
